interface IAppConfig {
  isDev: boolean;
  isStaging: boolean;
  isQa: boolean;
  environment: string;
  gqlUrl: string;
  phraseProjectId: string;
  isPhraseEnabled: boolean;
}

const params = new URLSearchParams(window.location.search);

const appConfig: IAppConfig = {
  isDev: process.env.REACT_APP_NODE_ENV === 'development',
  isStaging: process.env.REACT_APP_NODE_ENV === 'staging',
  isQa: process.env.REACT_APP_NODE_ENV === 'qa',
  environment: process.env.REACT_APP_NODE_ENV as string,
  gqlUrl: process.env.REACT_APP_API_URL as string,
  phraseProjectId: process.env.REACT_APP_PHRASE_PROJECT_ID as string,
  isPhraseEnabled: Boolean(process.env.REACT_APP_PHRASE_ENABLED) && params.has('phrase'),
};

export default appConfig;
